module.exports = __webpack_public_path__ + "img/img_view_direct_skt_02.e202d0ea.png";